'use strict';

var React = require('react');
var SvgIcon = require('../../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var FacebookIcon = function FacebookIcon() {
  return React__default["default"].createElement(SvgIcon["default"], {
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 112.196 112.196"
  }, React__default["default"].createElement("circle", {
    cx: "56.098",
    cy: "56.098",
    r: "56.098",
    fill: "#3b5998"
  }), React__default["default"].createElement("path", {
    d: "M70.201,58.294h-10.01v36.672H45.025V58.294h-7.213V45.406h7.213v-8.34 c0-5.964,2.833-15.303,15.301-15.303L71.56,21.81v12.51h-8.151c-1.337,0-3.217,0.668-3.217,3.513v7.585h11.334L70.201,58.294z",
    fill: "#fff"
  }));
};

module.exports = FacebookIcon;
